import * as moment from 'moment';
import MomentEnum from '../enums/MomentEnum';
var localeMap = {
    'zh': 'zh-cn',
    'en': 'en-gb',
    'no': 'nb',
};
export var getLocale = function (locale) {
    try {
        locale = localeMap[locale] || locale;
        require("moment/locale/".concat(locale));
        return locale;
    }
    catch (error) {
        console.log('[getLocale: error] : ', error);
        require("moment/locale/".concat(localeMap.en));
        return localeMap.en;
    }
};
export var getWeekDaysByWeekStarter = function (weekStarter, t, locale) {
    locale = getLocale(locale) || localeMap.en;
    var weekDays = [];
    var screenReaderDays = {};
    var dayIndex = moment()
        .locale(MomentEnum.en)
        .startOf(MomentEnum.week) // startOf() is locale aware
        .add(weekStarter, MomentEnum.days);
    dayIndex = moment(dayIndex).locale(locale); // returning to the current locale
    for (var i = 0; i < 7; i++) {
        var weekDay = dayIndex.format(MomentEnum.shortWeekDayName);
        //@ts-ignore
        weekDays.push(weekDay);
        screenReaderDays[weekDay] = dayIndex.format(MomentEnum.fullWeekDayName);
        dayIndex.add(1, MomentEnum.days);
    }
    return { weekDays: weekDays, screenReaderDays: screenReaderDays };
};
export var getLocaleDayMobile = function (locale, date, format) {
    locale = getLocale(locale) || localeMap.en;
    return moment(date).locale(locale).format(format);
};
export var getHeaderDay = function (weekStart, locale, add, format) {
    locale = getLocale(locale) || localeMap.en;
    return moment(weekStart)
        .locale(locale)
        .add(add, MomentEnum.days)
        .format(format);
};
export function getDatesEventsRange(dates) {
    var keys = Object.keys(dates).sort(function (a, b) { return moment(a).valueOf() - moment(b).valueOf(); });
    var eventsDateRangeStart = moment(keys[0]);
    var eventsDateRangeEnd = moment(keys[keys.length - 1]);
    return { eventsDateRangeStart: eventsDateRangeStart, eventsDateRangeEnd: eventsDateRangeEnd };
}
export function getMomentWithFormat(date, locale, format) {
    locale = getLocale(locale) || localeMap.en;
    return moment(date).locale(locale).format(format);
}
export function shortMomentDate(date, locale) {
    locale = getLocale(locale) || localeMap.en;
    return moment(date).locale(locale).format(MomentEnum.shortMomentDate);
}
export function tFormatMomentDate(date, locale, t) {
    locale = getLocale(locale) || localeMap.en;
    return moment(date).locale(locale).format(t('Google_Calendar_Picker_Month'));
}
export function compareDates(endDate) {
    var format = MomentEnum.yearMonthDay;
    var today = dateToMomentWithFormat(new Date(), format);
    var dateToCompare = dateToMomentWithFormat(endDate, format);
    return dateToCompare < today;
}
export function dateToMomentWithFormat(date, format) {
    return moment(date).format(format);
}
export function getAriaLabelStr(currentWeekRange) {
    var time;
    var start = currentWeekRange[0].eventDate;
    var end = currentWeekRange[currentWeekRange.length - 1].eventDate;
    if (moment(start).format(MomentEnum.yearMonthDay) ===
        moment(end).format(MomentEnum.yearMonthDay)) {
        time =
            moment(start).format(MomentEnum.shortMonthName) +
                ' ' +
                moment(start).format(MomentEnum.fullDayOfMonth) +
                ' - ' +
                moment(end).format(MomentEnum.fullDayOfMonth) +
                ', ' +
                moment(start).format(MomentEnum.fullYear);
    }
    else {
        time =
            moment(start).format(MomentEnum.shortMonthName) +
                ' ' +
                moment(start).format(MomentEnum.fullDayOfMonth) +
                ' - ' +
                moment(end).format(MomentEnum.shortMonthName) +
                ' ' +
                moment(end).format(MomentEnum.fullDayOfMonth) +
                ', ' +
                moment(start).format(MomentEnum.fullYear);
    }
    return time;
}
export function getTime(is24format, timeToFormat) {
    var time;
    if (is24format) {
        time = timeToFormat.format("".concat(MomentEnum.fullHour, ":").concat(MomentEnum.fullMinute));
    }
    else {
        if (timeToFormat.format(MomentEnum.fullMinute) > 0) {
            time = timeToFormat.format("".concat(MomentEnum.shortHour, ":").concat(MomentEnum.fullMinute, " ").concat(MomentEnum.ampm));
        }
        else {
            time = timeToFormat.format("".concat(MomentEnum.shortHour, " ").concat(MomentEnum.ampm));
        }
    }
    return time;
}
export function compareFormat(startTime, endTime) {
    if (startTime.split(' ')[1] === endTime.split(' ')[1]) {
        return startTime.split(' ')[0];
    }
    return startTime;
}
export function getEventTime(event) {
    var start = event.start;
    var end = event.end;
    var time;
    if (moment(start).format(MomentEnum.yearMonthDay) ===
        moment(end).format(MomentEnum.yearMonthDay)) {
        time =
            moment(start).format(MomentEnum.yearMonthDay) +
                ', ' +
                moment(start).format(MomentEnum.timeFormat) +
                '-' +
                moment(end).format(MomentEnum.timeFormat);
    }
    else {
        time =
            moment(start).format(MomentEnum.yearMonthDay) +
                ', ' +
                moment(start).format(MomentEnum.timeFormat) +
                ' - ' +
                moment(end).format(MomentEnum.yearMonthDay) +
                ', ' +
                moment(end).format(MomentEnum.timeFormat);
    }
    return time;
}
//# sourceMappingURL=momentUtils.js.map